import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { getProfitabilityByPeriod } from '@alfa-bank/site-invest-emitents-common/helpers';
import { isNumber } from '@alfa-bank/site-invest-common/helpers/numbers/is-number';

import { PROFITABILITY_TYPE_DAY } from '../../constants';
import { createLinkForPage, truncateString } from '../../helpers';
import { defaultBaseUrlToAssetConfig } from '../../config';

import type { TAssetCard } from './models';

export const AssetCard: FC<TAssetCard> = ({
    Block,
    Grid,
    Link,
    Logo,
    ProfitabilityCell,
    Text,
    asset,
    baseUrlToAsset = defaultBaseUrlToAssetConfig,
    className,
    dataTestId,
    onClickAsset,
    styles,
    theme = 'white',
}) => {
    const { name, profitabilities } = asset;
    const { profitabilityPercent } = getProfitabilityByPeriod(
        PROFITABILITY_TYPE_DAY,
        profitabilities ?? []
    );
    const columnsWidth = isNumber(profitabilityPercent) ? [24, 8, null, null] : [24, 8, null, 0];

    return (
        <Link
            className={cn(className, styles.external, styles.wrapper)}
            dataTestId={dataTestId}
            href={createLinkForPage(baseUrlToAsset, asset)}
            noUnderline
            onClick={onClickAsset(asset.name)}
        >
            <Block
                borderRadius={12}
                className={cn(styles.external, styles.block)}
                notPadded
                overflowHidden
                styler={{ padding: 8 }}
                theme={theme}
            >
                <Grid alignment="center" collapse columnsWidth={columnsWidth}>
                    <Logo
                        assetName={name}
                        issuer={asset.issuer}
                        mainSize={24}
                        size={24}
                        textView="secondary-large"
                    />
                    <></>
                    <Text
                        className={cn(styles.external, styles.assetName)}
                        styler={{ margin: 0 }}
                        view="primary-medium"
                    >
                        {truncateString(name, 10)}
                    </Text>
                    <ProfitabilityCell profitabilityPercent={profitabilityPercent} />
                </Grid>
            </Block>
        </Link>
    );
};
